export default __webpack_public_path__ + "static/media/loading_transparent.aea75769.gif";